<script>
    import Config from '@/config'
    import {bindCar} from '@/api';
    import {Field, Button, Checkbox, CheckboxGroup} from 'vant';

    export default {
        components: {
            [Field.name]: Field,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        props: {
            query: {
                type: String
            }
        },
        data() {
            return {
                type: '',
                vin: null,
                carNumber: '',
                isDefault: false,

                loading: false
            };
        },
        watch: {
            $route(to) {
                console.log(to)
                this.vin = this.type = this.carNumber = '';

                if (to.name === 'bingCar') {
                    this.vin = to.query.vin;
                }
            }
        },
        computed: {
            disabled() {
                return this.carNumber.length < 7;
            }
        },
        mounted() {
            window.document.title = '速电通-绑定爱车';

            this.vin = this.query;
        },
        methods: {
            bindCar() {
                this.loading = true;
                bindCar({carNumber: this.carNumber, type: this.type, vin: this.vin, isDefault: this.isDefault}).then(response => {
                    if (response.data.code === Config.successCode) {
                        this.$router.go(-1);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<template>
    <div id="bindCar">
        <van-field v-model="carNumber" clearable label="车牌号" placeholder="请输入车牌号" titleWidth="64px"/>
        <van-field v-model="type" clearable label="品牌" placeholder="请输入汽车品牌" titleWidth="64px"/>
        <van-field v-if="vin" v-model="vin" clearable label="识别码" placeholder="请输入车辆识别码(vin)" titleWidth="64px"/>
        <van-checkbox v-model="isDefault" icon-size="16px" checked-color="#009251">设为默认车牌</van-checkbox>
        <div class="submit-button">
            <van-button :disabled="disabled" :loading="loading" @click="bindCar" block color="#009251" loading-text="查询中...">绑定</van-button>
        </div>
    </div>
</template>

<style scoped>
    #bindCar .van-checkbox {
        padding: 16px;
        font-size: 12px;
    }

    #bindCar .submit-button {
        padding: 0 24px;
    }

    #bindCar .van-button {
        box-shadow: 0 3px 6px 1px rgba(0, 146, 81, 0.41);
    }
</style>
